import React from 'react';
import NotificationsIndexPage from '../notifications_index_page/NotificationsIndexPage';
import { BUYER_NOTIFICATION_APPROVALS_TYPES_MAP } from '../../utils/NotificationUtils';

export default function NotificationsApprovals() {
	// only buyer_types because approvals doesnt exist for 3rd party Supplier.
	return (
		<NotificationsIndexPage
			key="NotificationsApprovals"
			preAppliedFilters={{
				notificationTypes: BUYER_NOTIFICATION_APPROVALS_TYPES_MAP.map((filter) => {
					if (filter.children && filter.children.length > 0) {
						return filter.children.map((child) => child.key);
					}
					return filter.key;
				}).flat(),
			}}
			typeFilters={BUYER_NOTIFICATION_APPROVALS_TYPES_MAP}
		/>
	);
}
